import * as React from 'react';
import {FunctionComponent, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../Support/with_presenter';
import {CrewICalPresenter} from './CrewICalPresenter';
import {classNames} from '../../Support/classNames';
import {NetworkRequestStatusView} from '../Utils/NetworkRequestStatusView';

interface OwnProps {
    className?: string;
}

const CrewICalComponent: FunctionComponent<OwnProps & PresenterProps<CrewICalPresenter>> = observer(
    ({className, presenter}) => {
        const [copied, setCopied] = useState(false);

        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5>iCal</h5>
                </div>
                <div className="card-body">
                    <p>Add your crew events to your personal calendar</p>
                    <NetworkRequestStatusView
                        result={presenter.crewIcalUrl}
                        loader={() => {
                            return (
                                <div className="input-group mb-3 skeleton">
                                    <input type="text" className="form-control" value="" readOnly />
                                    <button className="btn btn-primary input-group-text" style={{width: 80}}>
                                        {copied ? <i className="bi bi-check" /> : 'Copy'}
                                    </button>
                                </div>
                            );
                        }}
                        error={() => {
                            return (
                                <div className="input-group mb-3 skeleton">
                                    <input type="text" className="form-control" value="" readOnly />
                                    <button className="btn btn-primary input-group-text" style={{width: 80}}>
                                        {copied ? <i className="bi bi-check" /> : 'Copy'}
                                    </button>
                                </div>
                            );
                        }}
                        component={(crewICalUrl) => {
                            return (
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" value={crewICalUrl} readOnly />
                                    <button
                                        className="btn btn-primary input-group-text"
                                        style={{width: 80}}
                                        onClick={() => {
                                            navigator.clipboard.writeText(crewICalUrl).then(() => {
                                                setCopied(true);
                                            });
                                        }}
                                    >
                                        {copied ? <i className="bi bi-check" /> : 'Copy'}
                                    </button>
                                </div>
                            );
                        }}
                    />
                </div>
            </div>
        );
    },
);

export const CrewICal = withPresenter<CrewICalPresenter, OwnProps>(
    (props, component) => new CrewICalPresenter(component.network.me),
    CrewICalComponent,
);
